export const ACCEPTED_FILE_TYPES = {
	image: {
		"image/jpeg": [".JPEG"],
		"image/png": [".PNG"],
		"image/svg+xml": [".SVG"],
	},
	favicon: {
		"image/x-icon": [".ICO"],
		"image/png": [".PNG"],
		"image/svg+xml": [".SVG"],
	},
	spreadsheet: {
		"application/vnd.ms-excel": [".XLS"],
		"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [".XLSX"],
		"text/csv": [".CSV"],
		"application/vnd.apple.numbers": [".NUMBERS"],
	},
	pdf: {
		"application/pdf": [".PDF"],
	},
};

export const ACCEPTED_FILE_MIME_TYPES = {
	image: ["image/png", "image/jpeg", "image/svg+xml"],
	favicon: ["image/x-icon", "image/png", "image/svg+xml"],
	spreadsheet: [
		"application/vnd.ms-excel",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
		"text/csv",
		"application/vnd.apple.numbers",
	],
	pdf: ["application/pdf"],
};

export type AcceptedFileType = keyof typeof ACCEPTED_FILE_TYPES;

const MB = 1_000_000;
export const DEFAULT_ACCEPTED_FILE_SIZE_PER_TYPE: Record<AcceptedFileType, number> = {
	image: 2 * MB,
	favicon: 1 * MB,
	spreadsheet: 10 * MB,
	pdf: 10 * MB,
};

export const getDropzoneFileTypes = (fileTypes: AcceptedFileType[]) => {
	return fileTypes.reduce((acc, cur) => {
		return Object.assign(acc, ACCEPTED_FILE_TYPES[cur]);
	}, {});
};

export const getFileExtensionsByFileTypes = (fileTypes: AcceptedFileType[]) => {
	return fileTypes.reduce((acc, cur) => {
		const fileExtensions = Object.values(ACCEPTED_FILE_TYPES[cur]).flat();
		return [...acc, ...fileExtensions];
	}, [] as string[]);
};

export const getFileMimesByFileTypes = (fileTypes: AcceptedFileType[]) => {
	return fileTypes.reduce((acc, cur) => {
		const fileMimes = Object.values(ACCEPTED_FILE_MIME_TYPES[cur]);
		return [...acc, ...fileMimes];
	}, [] as string[]);
};

export const getMaxDefaultMaxFileSizeByFileTypes = (fileTypes: AcceptedFileType[]) => {
	return Math.max(...fileTypes.map((fileType) => DEFAULT_ACCEPTED_FILE_SIZE_PER_TYPE[fileType]));
};
